import { useGetEventFeatureFlagsQuery } from '@graphql/generated';
import { useQueryParamHelper } from '@shared/core/queryString';
import { useCallback } from 'react';

export const useEventFeatureFlags = ({ eventHandle, skip }: { eventHandle: string; skip?: boolean }) => {
  const { data, loading } = useGetEventFeatureFlagsQuery({
    variables: { eventHandle },
    batchMode: 'fast',
    skip,
  });

  const { getValueString } = useQueryParamHelper();
  const isEventFeatureFlagEnabledViaQueryParam = useCallback(
    (flag: string) => {
      return getValueString(`feature.${flag}`) === 'true';
    },
    [getValueString],
  );

  const isEventFeatureFlagEnabled = useCallback(
    (flag: string) => {
      return data?.eventByName?.featureFlags?.includes(flag) || isEventFeatureFlagEnabledViaQueryParam(flag);
    },
    [data, isEventFeatureFlagEnabledViaQueryParam],
  );

  return {
    loadingEventFeatureFlags: loading,
    isEventFeatureFlagEnabled,
  };
};
